/**
 * Can be retrieved from the server
 */

export const SYNC_GUILD_MEMBERS_PERIOD = 1000 * 3600 * 1; // 1 hour

export const SYNC_ROSTERS_CHARACTERS_ITEMS_PERIOD = 1000 * 3600 * 1; // 1 hour
export const SYNC_ROSTERS_CHARACTERS_ITEMS_FAST_PERIOD = 1000 * 60 * 15; // 15 minutes

export const SYNC_BNET_CHARACTERS_PERIOD = 1000 * 3600;

export const CHARACTERS_FILTER_LAST_MODIFIED_THRESHOLD = 1000 * 3600 * 24 * 30;